"use client";

import { useEffect } from "react";
import { clearLocalePreference } from "@marketing-sites/l10n/preference/cookie";
import {
  CONSENT_CHANGED_EVENT,
  hasFunctionalConsent,
} from "@marketing-sites/marketo/consent";

import { LOCALE_UI_ENABLED } from "@/lib/l10n/config";

// In RootShell rather than the footer, which not every page renders.
export function LocalePreferenceConsentGuard() {
  useEffect(() => {
    if (!LOCALE_UI_ENABLED) return;

    const clearIfWithoutConsent = () => {
      if (!hasFunctionalConsent()) clearLocalePreference();
    };

    clearIfWithoutConsent();
    window.addEventListener(CONSENT_CHANGED_EVENT, clearIfWithoutConsent);
    return () =>
      window.removeEventListener(CONSENT_CHANGED_EVENT, clearIfWithoutConsent);
  }, []);

  return null;
}
